import { Col, Row } from 'react-bootstrap';

import { SalaryTypeReport } from './SalaryTypeReport';
import Breadcrumb from '../../../../components/base/Breadcrumb';
import PagesHeader from '../../../../components/base/PagesHeader';
import { IBreadCrumb } from '../../../../types/base/BreadCrumb';
import CardComponent from '../../../../components/base/CardComponent';

export const SalaryType = () => {
  const breadcrumb: IBreadCrumb[] = [
    {
      name: 'Overview',
      href: '/dashboard',
    },
    {
      name: 'Reports',
      href: '/reports',
    },
    {
      name: 'Salary Types',
    },
  ];

  return (
    <>
      <Breadcrumb navItem={breadcrumb} />
      <Row className="d-flex">
        <Col md="6">
          <PagesHeader headingClass="fs-h1" pageTitle="Salary types" />
        </Col>
      </Row>
      <CardComponent>
        <SalaryTypeReport />
      </CardComponent>
    </>
  );
};
